import httpService from './httpService';

export const refreshToken = async () => {
	const { data } = await httpService.post(`/token/refresh`, {});
	return data;
};

export const login = async (username: string, password: string) => {
	const { data } = await httpService.post(
		`/token`,
		{ username, password },
		{
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
			},
		},
	);
	return data;
};

export default { refreshToken, login };
